import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Creator.css";

export default function Creator() {
  return (
    <>
      <Navbar />
      <main className="creator-page">
        <section className="creator-card">
          <p className="creator-label">Website Creator</p>
          <h1>Sohail Asghar</h1>
          <p>
            This website was created by Sohail Asghar.
          </p>
          <a
            className="creator-link"
            href="https://sohailasghar.site/"
            target="_blank"
            rel="noreferrer"
          >
            Visit Website
          </a>
        </section>
      </main>
      <Footer />
    </>
  );
}
